<template style="background-color: white;">
    <div style="background-color: white; line-height: 1.7em;">
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <span v-for="data,index in marksheet_data" :key="index">
            <div style="display: flex; height: 100vh; background-color: #ccccff;">
                <div class="column pr-7" style="height: 90vh;">
                    <img class="img_back pl-10 pt-10 pb-10 pr-10" src="https://eduplusschool.s3.ap-south-1.amazonaws.com/wws/marksheet_school_image/marksheet_img_prep.png" height="70%" width="100%" />
                    <center>
                        <table style="width: 90%; border: none !important; background-color: #5229cc; color: white; margin-top: -10px;">
                            <tbody>
                                <tr class="table" style="font-size: 120%; font-weight: bold;">
                                    <th class="table" colspan="2">
                                        <center>Grade Key</center>
                                    </th>
                                </tr>
                                <tr class="table" v-for="g,index in data.leraner_marksheet.grading_scheme_details_for_marksheet" :key="index">
                                    <th style="width: 10%; border: none !important;">
                                        <img :src="g.grade_range_display_name" alt="" width="35%" />
                                    </th>
                                    <th style="width: 30%; font-size: 120%; text-align: left; font-weight: bold; border: none !important;" class="pl-2"><strong>{{ g.graderemark }}</strong></th>
                                </tr>
                            </tbody>
                        </table>
                    </center>
                </div>
                <div class="column pl-7" style="align-items: center; justify-content: center; display: flex;">
                    <div class="column" style="align-items: center; justify-content: center;">
                        <center><img src="https://eduplusschool.s3.ap-south-1.amazonaws.com/logo/WWS_Logo-01.png" width="120px" height="120px" alt="logo" class="logo" /></center>
                        <span class="school-name" style="text-transform: uppercase; font-size: xx-large; font-weight: bolder; color: #450676;">
                            <center>{{ data.org_basic_data.trust_name }}</center>
                        </span>

                        <div style="color: #450676; font-size: 18px;" class="pt-3">
                            <center>{{ data.marksheet_addr_line_1 }}</center>
                        </div>
                        <div style="color: #450676;" class="pt-3">
                            <center>{{ data.marksheet_addr_line_2 }}</center>
                        </div>
                        <br />
                        <center>
                            <img :src="data.marksheet_img" alt="" width="600px" height="300px" class="mt-1" />
                        </center>
                        <br />
                        <span style="text-transform: uppercase; font-size: x-large; font-weight: bolder; color: #5229cc;">
                            <center>Report Card - {{ data.ay }}</center>
                        </span>
                        <br />
                        <div class="row pl-10" style="text-transform: uppercase; font-size: large; font-weight: bolder; margin-top: -25px;">
                            <div class="col-12 mt-2 pt-2" style="padding-right: 15%; padding-left: 5%;">
                                <div class="row" style="border-bottom: #450676 1px solid;">
                                    Name :
                                    <div style="width: 70%; margin-left: 5px;">
                                        <span v-if="data.name_as_on_aadhar_card!='' && data.name_as_on_aadhar_card!=null">{{ data.name_as_on_aadhar_card }} </span>
                                        <span v-else>{{ data.first_last_name }} <span class="pl-1"></span> {{ data.sur_name }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6" style="padding-left: 5%;">
                                <div class="row" style="border-bottom: #450676 1px solid;">
                                    std : {{ data.standard }}
                                </div>
                            </div>
                            <div class="col-6" style="padding-right: 15%;">
                                <div class="row" style="border-bottom: #450676 1px solid;">
                                    Div : {{ data.div }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="pagebreak pt-1" style="display: flex; height: 100vh; border-top: 25px solid #5229cc !important; border-bottom: 25px solid #5229cc !important;">
                <div class="column pr-7">
                    <div v-for="s in data.leraner_marksheet.leraner_marksheet" :key="s.c_id">
                        <div class="table-breaked">
                            <span v-if="s.crs_image_list != ''" class="image">
                                <v-row style="position: absolute;">
                                    <v-col cols="12" sm="4" md="4" style="position: relative;" v-for="ci, index in s.crs_image_list" :key="index">
                                        <img :src="ci.file" v-if="index == 0" style="left: 2200%; top: 11%; position: absolute; opacity: 0.6;" width="50px" height="50px" alt="logo" class="ci-image" />
                                    </v-col>
                                </v-row>
                            </span>
                            <v-simple-table class="pl-5" flat dense>
                                <thead>
                                    <tr>
                                        <th class="suject_head crs_name">
                                            <strong>{{ s.crs_name }}</strong>
                                        </th>
                                        <th class="suject_head"><strong>Final</strong></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(header, index) in s.rubric_header" :key="index">
                                        <td class="fixed-width-rubric" style="font-weight: 500; line-height: 100%; font-size: 13px;padding-bottom: 2px;padding-top: 2px;">
                                            <span style="z-index: 2000 !important; position: relative;">{{ header }}</span>
                                        </td>
                                        <td>
                                            <img v-if="s.rubrics[index] != ''" :src="s.rubrics[index]" alt="" width="80%" class="pt-1" />
                                            <span v-if="s.rubrics[index] == ''"> </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                        </div>
                    </div>
                    <div class="column">
                        <img class="pl-5" src="@/assets/img_start_1.png" alt="" width="90px" height="85px" />
                        <img style="margin-left: 25%;" class="pl-5" src="https://eduplusschool.s3.ap-south-1.amazonaws.com/wws1course_image/course-264/Crs_Image2640ymgxzb6xd3.jpg " alt="" width="90px" height="85px" />
                        <img style="margin-left: 30%;" src="@/assets/img_start_2.png" alt="" width="85px" height="90px" />
                    </div>
                </div>
                <div class="column pl-7">
                    <div v-for="s in data.leraner_marksheet.leraner_marksheet_crs_2" :key="s.c_id">
                        <div class="table-breaked">
                            <span v-if="s.crs_image_list != ''" class="image">
                                <v-row style="position: absolute;">
                                    <v-col cols="12" sm="6" md="6" style="position: relative;" v-for="ci, index in s.crs_image_list" :key="index">
                                        <img :src="ci.file" v-if="index == 0" style="left: 2122%; position: absolute; opacity: 0.6;" width="80px" height="80px" alt="logo" class="ci-image" />
                                    </v-col>
                                </v-row>
                            </span>
                            <v-simple-table class="pr-5" flat dense>
                                <thead>
                                    <tr>
                                        <th class="suject_head crs_name">
                                            <strong>{{ s.crs_name }}</strong>
                                        </th>
                                        <th class="suject_head"><strong>Final</strong></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(header, index) in s.rubric_header" :key="index">
                                        <td class="fixed-width-rubric" style="font-weight: 500; line-height: 100%;font-size: 13px;padding-bottom: 2px;padding-top: 2px;">
                                            <span style="z-index: 2000 !important; position: relative;">{{ header }}</span>
                                        </td>
                                        <td>
                                            <img v-if="s.rubrics[index] != ''" :src="s.rubrics[index]" alt="" width="80%" class="pt-1" />
                                            <span v-if="s.rubrics[index] == ''"> </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                        </div>
                    </div>
                    <div class="mt-3">
                        <table class="mt-3 pr-2" style="width: 97.5%;">
                            <tr>
                                <td class="pt-2 pb-2 pl-2" style="width: 87.8%; border-right: 2px solid black;">
                                    <strong>ATTENDANCE</strong>
                                </td>

                                <td class="diagonalCross2">
                                    <strong>
                                        <span style="position: relative; left: 7%; top: -5px;"> </span>
                                        <span class="pt-2 ml-5" style="position: absolute; right: 2.5%;"> </span>
                                    </strong>
                                </td>
                            </tr>
                        </table>
                        <table class="mt-3 pr-2" style="width: 97.5%;">
                            <tr>
                                <td class="pt-2 pb-2 pl-2" style="width: 50%;"><strong>CLASS TEACHER’S NAME</strong></td>

                                <td class="pl-2"><strong>{{ data.inst_name }}</strong></td>
                            </tr>
                        </table>
                        <table class="mt-3 pr-2" style="width: 97.5%;">
                            <tr>
                                <td class="pt-2 pb-2 pl-2" style="width: 50%;"><strong>PRINCIPAL’S SIGNATURE</strong></td>

                                <td class="pl-2">
                                    <strong>
                                        <img v-if="org_id=='1'" src="https://eduplusschool.s3.ap-south-1.amazonaws.com/wws/principal_sign/wakad-removebg.png" width="100px" height="50px" alt="logo" />
                                        <img v-else src="https://eduplusschool.s3.ap-south-1.amazonaws.com/Role_link_icons/wws/2/chatgptimagesep22,2026,10_28_47amkz4i3o070g.png" width="100px" height="50px" alt="logo" />
                                    </strong>
                                </td>
                            </tr>
                        </table>
                        <table class="mt-3 pr-2" style="width: 97.5%;">
                            <tr>
                                <td class="pt-2 pb-2 pl-2" style="width: 50%;"><strong>PARENT’S SIGNATURE</strong></td>

                                <td></td>
                            </tr>
                        </table>
                        <table class="mt-3 pr-2" style="width: 97.5%;">
                            <tr>
                                <td class="pt-2 pb-2 pl-2" style="width: 50%;"><strong>PROMOTED TO</strong></td>

                                <td class="pl-2"><strong>{{ data.next_std }} -</strong></td>
                            </tr>
                        </table>
                    </div>
                    <div class="column">
                        <img class="pl-5" src="@/assets/img_end_1.png" alt="" width="80px" height="80px" style="margin-bottom: 15px;" />
                        <img class="pl-5" style="margin-left: 25%; margin-bottom: 15px;" src="https://eduplusschool.s3.ap-south-1.amazonaws.com/wws1course_image/course-263/Crs_Image263nsdm2eey938.jpg " alt="" width="80px" height="80px" />
                        <img class="" style="margin-left: 25%; margin-bottom: 15px;" src="@/assets/img_end_2.png" alt="" width="80px" height="80px" />
                    </div>
                </div>
            </div>
        </span>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        props: {
            org: Number,
        },
        data() {
            return {
                overlay: false,
                snackbar: false,
                search: "",
                snackbar_msg: "",
                color: "",
                snackbar: false,
                snackbar_msg: "",
                color: "",
                sel_std: null,
                sel_div: null,
                marksheet_data: [],
                org_id: null,
            };
        },

        methods: {
            print() {
                this.$store.state.drawer = false;
                let that = this;
                window.onafterprint = function () {
                    that.$store.state.drawer = true;
                };
                setTimeout(function () {
                    window.print();
                }, 100);
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onload() {
                const data = {
                    ay: this.sel_ay_data,
                    std: this.sel_std,
                    div: this.sel_div,
                };
                axios
                    .post("/WWSExamination/getPriPrimBulkAnnualMarkseetData", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.marksheet_data = res.data.data;
                        }
                        if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", res.data.fmsg); // show snackbar
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
        },
        mounted() {
            this.awspath = localStorage.getItem("awspath");
            this.sel_ay_data = localStorage.getItem("setay");
            this.sel_std = localStorage.getItem("setstd");
            this.sel_div = localStorage.getItem("setdiv");
            this.org_id = localStorage.getItem("EPS-org-id");
            this.onload();
        },
    };
</script>
<style scoped>
   .image {
        overflow: hidden;
        display: flex;
        /* justify-content: flex-end; */
    }

    .container {
      position: relative;
      width: 100%;
    }

    .overlay-image {
    position: relative;
      top: 0;
      left: 0;
      /* width: 10%;
      height: 10%; */
      z-index: 1; /* Ensure the image is displayed above the table */
      opacity: 0.5; /* Optional: Adjust the opacity of the image */
    }

    .ci-image {
        margin: 0;
        padding: 0;
        display: block;
    }

    .suject_head {
        text-transform: uppercase !important;
        font-size: 16px !important;
        font-weight: bold !important;
        color: black !important;
    }

    .fixed-width-rubric {
        width: 620px;
    }
    .diagonalCross2 {
        background: linear-gradient(to top left, #fff calc(50% - 1px), black, #fff calc(50% + 1px));
    }

    .table {
        border: 1px solid white !important;
        /* font-size: 17px !important; */
    }

    table,
    th,
    td {
        /* font-size: 17px !important; */
        border: 1px solid black;
        border-collapse: collapse;
    }

    .th {
        border: 1px solid black;
        border-bottom: 1px solid black;
        /* font-size: 17px !important; */
    }

    .column {
        flex: 1;
        padding: 10px;
    }

    @media print {
       
        .svg-content {
            width: 35%;
        }

        .img_back {
           
            height: 80%;
            width:100%;
        }
        
                 .logo {
        
                    margin-top: -100px !important;
                 }
        .pagebreak {
            page-break-before: always;
        }

        header,
        footer,
        nav,
        date {
            display: none !important;
        }

        table,
        td,
        tr {
            break-inside: avoid-page;
        }

        .no-display,
        .v-input__control,
        input[type="button"],
        input[type="submit"],
        input[type="reset"],
        #v-card {
            display: none !important;
        }

        v-card {
            border: none !important;
        }

        @page {
            margin-top: none;
            padding-top: none;
            size: 15in 10in !important;
            margin: 0mm;
        }
        .crs_name {
            width: 410px;
        }
        .table-breaked {
            page-break-inside: avoid;
            margin-top: 0.7rem;
        }
    }
</style>
